import { combineReducers } from 'redux';
import resize from './resize/reducer';
import { reducer as taskScheduler } from './taskScheduler';
import { reducer as list } from './list';
import { reducer as targetPower } from './targetPower';
import { serverTemplatesReducer as templates } from './templates';

export default combineReducers({
	resize,
	taskScheduler,
	list,
	templates,
	targetPower,
});
